import React, { useState } from 'react';
import '../styles/ActivityCard.css';

const ActivityCard = ({ activity, formatDate, onSelect }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);
  const activityImages = Array.isArray(activity.images) && activity.images.length > 0
    ? activity.images
    : Array.isArray(activity.image)
      ? activity.image
      : activity.image
        ? [activity.image]
        : [];
  const [currentImage, setCurrentImage] = useState(activityImages[0] || activity.placeholder);

  const handleImageError = () => {
    if (!imageError) {
      setCurrentImage(activity.placeholder);
      setImageError(true);
      setImageLoaded(false);
    }
  };

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  return (
    <article
      className="activity-card"
      role="button"
      tabIndex={0}
      aria-label={`Voir les photos et les détails de l’activité : ${activity.title}`}
      onClick={onSelect}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onSelect();
        }
      }}
    >
      {/* Header avec catégorie */}
      <div className="card-header">
        <div className="category-badge">
          <span className="category-text">{activity.category}</span>
        </div>
      </div>

      {/* Image avec fallback */}
      <div className="image-container">
        <img
          src={currentImage}
          alt={activity.title}
          className={`activity-image ${imageLoaded ? 'loaded' : ''}`}
          onLoad={handleImageLoad}
          onError={handleImageError}
        />
        {!imageLoaded && (
          <div className="image-skeleton">
            <div className="skeleton-shimmer"></div>
          </div>
        )}
      </div>

      {/* Contenu */}
      <div className="card-content">
        <div className="content-header">
          <h3 className="activity-title">{activity.title}</h3>
          <div className="activity-meta">
            <div className="meta-item">
              <span className="meta-text">{formatDate(activity.date)}</span>
            </div>
            <div className="meta-item">
              <span className="meta-text">{activity.location}</span>
            </div>
          </div>
        </div>

        <p className="activity-description">{activity.description}</p>

        <div className="card-footer">
          <div className="participants-info">
            <span className="participants-count">
              {activity.participants > 0
                ? `${activity.participants} participant${activity.participants > 1 ? 's' : ''}`
                : 'Information'
              }
            </span>
          </div>
          <span className="activity-card-link">Voir les photos</span>
        </div>
      </div>

      {/* Décoration */}
      <div className="card-decoration">
        <div className="decoration-line"></div>
      </div>
    </article>
  );
};

export default ActivityCard;